// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General container styling */
.analytics-container {
  padding: 10px 10px 0px 20px;
  max-width: 1000px;
  margin: 0 auto;
  background-color: #f5f5f5;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h2 {
  color: #305e7a;
  text-align: center;
  padding-bottom: 10px;
}

/* Styling for each chart section */
.chart-section {
  margin-top: 20px;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  border: 1px solid #ddd;
  padding-left: 90px;
}

h3 {
  color: #305e7a;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  padding-bottom: 30px;
}

/* Styling for the legend of the Pie Chart */
.recharts-legend-item {
  font-size: 12px;
  font-weight: bold;
}

/* Responsive chart adjustments */
.responsive-chart {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

/* Tooltip styling */
.recharts-tooltip-wrapper {
  background-color: white;
  border-radius: 5px;
  padding: 5px;
  font-size: 12px;
}
.dual-chart-container {
  display: flex;
  justify-content: space-around; /* Space between both charts */
  align-items: center;
}

.chart-wrapper {
  width: 45%; /* Adjust width to fit both charts */
}

/* 
@keyframes flashing-green {
  0% { fill: #78b348; } 
  50% { fill: #7fbb6b; } 
  100% { fill: #78b348; }
}

@keyframes flashing-orange {
  0% { fill: #ec8d61; }
  50% { fill: #dc6967; }
  100% { fill: #ec8d61; }
}


.flashing-running {
  animation: flashing-green 3.5s infinite ease-in-out;
}

.flashing-pending {
  animation: flashing-orange 3.5s infinite ease-in-out;
} */
 
/* Ensures the container holds both charts side by side */
.chart-container {
  display: flex;
  justify-content: space-between; /* Evenly distribute charts */
  align-items: center;
  gap: 20px; /* Spacing between charts */
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
  margin-bottom: 20px;
}

/* Ensures individual charts take appropriate space */
.chart-item {
  flex: 1 1; /* Equal width for both charts */
  text-align: center;
}

/* Adjust heights */
.small-chart {
  max-width: 45%;
}

.large-chart {
  max-width: 55%;
}

/* Ensure responsiveness */
@media (max-width: 768px) {
  .chart-container {
    flex-direction: column;
  }

  .small-chart,
  .large-chart {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/JobAnalytics.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,6BAA6B,EAAE,8BAA8B;EAC7D,mBAAmB;AACrB;;AAEA;EACE,UAAU,EAAE,oCAAoC;AAClD;;AAEA;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH,yDAAyD;AACzD;EACE,aAAa;EACb,8BAA8B,EAAE,6BAA6B;EAC7D,mBAAmB;EACnB,SAAS,EAAE,2BAA2B;EACtC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,SAAO,EAAE,gCAAgC;EACzC,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* General container styling */\n.analytics-container {\n  padding: 10px 10px 0px 20px;\n  max-width: 1000px;\n  margin: 0 auto;\n  background-color: #f5f5f5;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\nh2 {\n  color: #305e7a;\n  text-align: center;\n  padding-bottom: 10px;\n}\n\n/* Styling for each chart section */\n.chart-section {\n  margin-top: 20px;\n  padding: 15px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  border: 1px solid #ddd;\n  padding-left: 90px;\n}\n\nh3 {\n  color: #305e7a;\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  padding-bottom: 30px;\n}\n\n/* Styling for the legend of the Pie Chart */\n.recharts-legend-item {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n/* Responsive chart adjustments */\n.responsive-chart {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 10px;\n}\n\n/* Tooltip styling */\n.recharts-tooltip-wrapper {\n  background-color: white;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 12px;\n}\n.dual-chart-container {\n  display: flex;\n  justify-content: space-around; /* Space between both charts */\n  align-items: center;\n}\n\n.chart-wrapper {\n  width: 45%; /* Adjust width to fit both charts */\n}\n\n/* \n@keyframes flashing-green {\n  0% { fill: #78b348; } \n  50% { fill: #7fbb6b; } \n  100% { fill: #78b348; }\n}\n\n@keyframes flashing-orange {\n  0% { fill: #ec8d61; }\n  50% { fill: #dc6967; }\n  100% { fill: #ec8d61; }\n}\n\n\n.flashing-running {\n  animation: flashing-green 3.5s infinite ease-in-out;\n}\n\n.flashing-pending {\n  animation: flashing-orange 3.5s infinite ease-in-out;\n} */\n \n/* Ensures the container holds both charts side by side */\n.chart-container {\n  display: flex;\n  justify-content: space-between; /* Evenly distribute charts */\n  align-items: center;\n  gap: 20px; /* Spacing between charts */\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border: 1px solid #ddd;\n  margin-bottom: 20px;\n}\n\n/* Ensures individual charts take appropriate space */\n.chart-item {\n  flex: 1; /* Equal width for both charts */\n  text-align: center;\n}\n\n/* Adjust heights */\n.small-chart {\n  max-width: 45%;\n}\n\n.large-chart {\n  max-width: 55%;\n}\n\n/* Ensure responsiveness */\n@media (max-width: 768px) {\n  .chart-container {\n    flex-direction: column;\n  }\n\n  .small-chart,\n  .large-chart {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
